import React, { useState, useEffect, useRef } from "react";
import "../../styles.scss";
import image1 from "../../assets/globalImgs/profile.png";
import { Link, useNavigate } from "react-router-dom";
import SignoutComponent from "../auth/signout";
import { useUser } from '../../utils/userContext';
import Search from "./globalsearch";
import useConfiguration from '../../utils/ConfigurationContext';
import axios from 'axios';
import useHandleErrors from "../../utils/user.utils";
import { toast } from "react-toastify";


export default function TopNavBar() {
  const [showSignout, setShowSignout] = useState(false);
  const { user } = useUser();
  const config = useConfiguration();
  const [notifications, setNotifications] = useState([]);
  const [displayNotifications, setDisplayNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const handleErrors = useHandleErrors();
  const hasFetchedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch notifications when component mounts
    if (!hasFetchedRef.current) {
      fetchNotifications();
      hasFetchedRef.current = true;
    }
  }, []);

  // Function to fetch notifications
  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const path = `/getNotifications?employeeId=${user?.EmployeeId}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      const response = await axios.get(URL, config);
      if (response.status === 200) {
        setNotifications(response.data.Notifications);
        setDisplayNotifications(response.data.Notifications.slice(0, 3));
      }
      else {
        handleErrors(response);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      if (error.response) {
        if (error.response.status === 404) {
          // Handle 404 status code separately
          setNotifications([]);
          setDisplayNotifications([])
        } else {
          handleErrors(error.response);
        }
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Function to handle "Next" click and delete viewed notifications
  const handleNextClick = async () => {
    const viewedNotificationIds = displayNotifications.map(n => n.id);

    try {
      const path = "/notifications";
      const URL = process.env.REACT_APP_BE_URL + path;
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await axios.post(URL, { Ids: viewedNotificationIds }, config);
      if (response.status === 200) {
        // Fetch the latest notifications again after deleting the viewed ones
        fetchNotifications();
      } else {
        handleErrors(response);
      }
    } catch (error) {
      console.error('Error deleting notifications:', error);
      if (error.response) {
        if (error.response.status === 404) {
          // Handle 404 status code separately
          setNotifications([]);
          setDisplayNotifications([])
        } else {
          handleErrors(error.response);
        }
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  // Function to format timestamps
  // const formattedTime = (timestamp) => {
  //   const date = new Date(timestamp);
  //   const hours = date.getHours();
  //   const minutes = date.getMinutes();
  //   const ampm = hours >= 12 ? 'pm' : 'am';
  //   return `${hours % 12 || 12}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
  // };

  const formattedTime = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0'); // Months are 0-based
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const handleSignoutClick = () => {
    setShowSignout(true);
  };

  const handleSignoutClose = () => {
    setShowSignout(false);
  };
  console.log("user", user)

  const routes = [
    { path: "/", label: "Login" },
    { path: "/home", label: "Home" },
    { path: "/Dashboard", label: "Dashboard" },
    { path: "/signout", label: "Sign Out" },
    { path: "/profile", label: "Profile" },
    { path: "/forgotpassword", label: "Forgot Password" },
    { path: "/onboardemployee", label: "Onboard Employee" },
    { path: "/assignasset", label: "Assign Asset" },
    // { path: "/welcomekit", label: "Welcome Kit" },
    { path: "/offboardemployee", label: "Offboard Employee" },
    { path: "/assethandover", label: "Asset Handover" },
    { path: "/settlement", label: "Settlement" },
    { path: "/RegisterAsset", label: "Register Asset" },
    { path: "/AssetInventory", label: "Asset Inventory" },
    { path: "/AssignAssetList", label: "Assign Asset List" },
    { path: "/AssignedAssetList", label: "Assigned Asset List" },
    { path: "/AssetMasterReport", label: "Asset Master Report" },
    { path: "/SubmitClaims", label: "Submit Claims" },
    { path: "/ClaimStatus", label: "Claim Status" },
    { path: "/ClaimReport", label: "Claim Report" },
    { path: "/SubmitTimesheet", label: "Submit Timesheet" },
    { path: "/ViewTimesheet", label: "View Timesheet" },
    { path: "/ApproveTimesheet", label: "Approve Timesheet" },
    { path: "/TimesheetReport", label: "Timesheet Report" },
    { path: "/OnboardProjects", label: "Onboard Projects" },
    { path: "/AssignProjects", label: "Assign Projects" },
    { path: "/SubmitLeave", label: "Submit Leave" },
    { path: "/LeaveReport", label: "Leave Report" },
    { path: "/Payslips", label: "Payslips" },
    { path: "/PersonalInformation", label: "Personal Information" },
    { path: "/MedicalInsurance", label: "Medical Insurance" },
    { path: "/ExitRequest", label: "Exit Request" },
    { path: "/ProfileSearch", label: "Profile Search" },
    { path: "/EmployeeSeparation", label: "Employee Separation" },
    { path: "/UploadPolicy", label: "Upload Policy" },
    { path: "/policies", label: "Policies" },
    { path: "/GuestRegistartion", label: "Guest Registration" },
    { path: "/GuestList", label: "Guest List" },
    { path: "/Complaint", label: "Complaint" },
    { path: "/HrConnect", label: "HR Connect" },
    { path: "/Employees", label: "Employee Management" },
    { path: "/EmployeeDetails/:employeeId", label: "Employee Details" },
    { path: "/Uploadcenter", label: "Upload Center" },
    { path: "/Permissions", label: "Permissions" },
    { path: "/AdvanceSalary", label: "Advance Salary" },
    { path: "/SubmitRequest", label: "Submit Request" },
    { path: "/RequestStatus", label: "Request Status" },
    { path: "/RequestReport", label: "Request Report" },
    { path: "/EmployeeUpdate/:employeeId", label: "Employee Update" },
    { path: "/test", label: "Test" },
    { path: "/holidays", label: "Holidays" },
    { path: "/announcements", label: "Announcements" },
    { path: "/master-reports", label: "Master Reports" },
  ];


  // const [sessionTimeLeft, setSessionTimeLeft] = useState(null);

  // useEffect(() => {
  //   // Check and start the timer
  //   const loginTime = localStorage.getItem('loginTime');
  //   if (loginTime) {
  //     const loginTimestamp = parseInt(loginTime, 10);
  //     const currentTime = Date.now();
  //     const sessionDuration = 60 * 60 * 1000; // 1 hour in milliseconds
  //     const timeLeft = sessionDuration - (currentTime - loginTimestamp);

  //     if (timeLeft > 0) {
  //       setSessionTimeLeft(Math.ceil(timeLeft / 1000)); // Convert to seconds
  //     } else {
  //       setSessionTimeLeft(0);
  //       toast.info("Session expired. Please log in again.", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //       navigate("/"); // Redirect to login page if session expired
  //     }
  //   }
  // }, [navigate]);

  // useEffect(() => {
  //   // Update the timer every second
  //   const interval = setInterval(() => {
  //     if (sessionTimeLeft > 0) {
  //       setSessionTimeLeft(prevTime => {
  //         const newTime = prevTime - 1;
  //         localStorage.setItem('remainingTime', newTime);
  //         return newTime;
  //       });
  //     } else {
  //       clearInterval(interval);
  //       toast.info("Session expired. Please log in again.", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //       navigate("/"); // Redirect to login page if session expired
  //     }
  //   }, 1000);

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(interval);
  // }, [sessionTimeLeft, navigate]);

  // useEffect(() => {
  //   // Retrieve remaining time from localStorage on mount
  //   const remainingTime = parseInt(localStorage.getItem('remainingTime'), 10);
  //   if (!isNaN(remainingTime)) {
  //     setSessionTimeLeft(remainingTime);
  //   }
  // }, []);

  // const formatTime = (totalSeconds) => {
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = totalSeconds % 60;
  //   return `${hours}h ${minutes}m ${seconds}s`;
  // };
  return (
    <div>
      <div class="app-top-navbar">
        <div class="app-navbar-custom">
          <nav class="navbar navbar-expand-lg navbar-light p-0">
            <div className="app-search-bar device-search">
              {/* <div className="org-brand">
                {config?.organisationLogo && (
                  <img src={config?.organisationLogo} alt="Logo" className="org-logo" />
                )}
                <div className="logo-text">{config?.organisationName}</div>
              </div> */}
              <div className="org-brand">
                {config?.organisationLogo && (
                  <div className="logo">
                    <img src={config?.organisationLogo} alt="Logo" />
                  </div>
                )}
                <div className="logo-text">{config?.organisationName}</div>
              </div>
              <form className="search-form">
                <div className="input-prepend input-append">
                  <div className="btn-group">
                    <Search routes={routes} />
                  </div>
                </div>
              </form>
            </div>
            {/* <div className="app-session-timeout">
              <div className="session-timeout-custom">
                <nav className="navbar navbar-expand-lg navbar-light p-0">
                  <div className="session-timeout-bar">
                    <div className="session-timeout-text">
                      <p>
                        <span style={{ color: '#25b740', marginRight: '8px' }}>Active Session Timer:</span>
                        <span style={{ color: sessionTimeLeft <= 60 ? '#dc3545' : '#004f7c' }}>
                          {sessionTimeLeft !== null ? formatTime(sessionTimeLeft) : 'Calculating...'}
                        </span>
                      </p>
                    </div>
                  </div>
                </nav>
              </div>
            </div> */}
            <div>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-label="Toggle navigation"
              >
                <i class="ri-menu-3-line"></i>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto navbar-list align-items-center">
                  <li class="nav-item nav-icon">
                    <Link to={"/home"} class="circle" title="Go to Home" rel="tooltip">
                      <i class="ri-home-4-fill"></i>
                    </Link>
                  </li>
                  <li class="nav-item nav-icon search-content">
                    <a
                      href="#"
                      class="rounded"
                      id="dropdownSearch"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="ri-search-line"></i>
                      <span class="dots"></span>
                    </a>
                    <div
                      class="app-search-bar app-sub-dropdown dropdown-menu"
                      aria-labelledby="dropdownSearch"
                    >
                      <form action="#" class="searchbox p-2">
                        <div class="form-group mb-0 position-relative">
                          <input
                            type="text"
                            class="text search-input font-size-12"
                            placeholder="Type here to search..."
                          />
                          <a href="#" class="search-link">
                            <i class="las la-search"></i>
                          </a>
                        </div>
                      </form>
                    </div>
                  </li>

                  <li class="nav-item nav-icon">
                    <a
                      href="#"
                      class="circle"
                      title="User Manual"
                      rel="tooltip"
                    >
                      <i class="ri-question-fill"></i>
                    </a>
                  </li>
                  <li class="nav-item dropdown nav-icon">
                    <a
                      href="#"
                      class="circle dropdown-toggle"
                      data-toggle="dropdown"
                      title="Quick Actions"
                      rel="tooltip"
                      id="createDropdownMenuButton"
                    >
                      <i class="ri-timer-flash-fill"></i>
                    </a>
                    <div class="app-sub-dropdown create-dropdown dropdown-menu">
                      <div class="card shadow-none m-0">
                        <div class="card-header cust-title p-3">
                          <div class="d-flex align-items-center justify-content-between">
                            <h6 class="mb-0">Quick Actions</h6>
                          </div>
                        </div>
                        <div class="card-body p-0 sub-card">
                          <Link to={"/SubmitTimesheet"} class="app-sub-card">
                            <div class="d-flex align-items-center p-3">
                              <div class="icon app-icon-box icon-text bg-body rounded">
                                T
                              </div>
                              <div>
                                <h6>Timesheet</h6>
                                <p class="mb-0 font-size-14">
                                  Submit Timesheet
                                </p>
                              </div>
                            </div>
                          </Link>
                          <a href={"/SubmitLeave"} class="app-sub-card">
                            <div class="d-flex align-items-center p-3">
                              <div class="icon app-icon-box icon-text bg-body rounded">
                                L
                              </div>
                              <div>
                                <h6>Leave Management</h6>
                                <p class="mb-0 font-size-14">Apply Leave</p>
                              </div>
                            </div>
                          </a>
                          <a href={"/SubmitClaims"} class="app-sub-card">
                            <div class="d-flex align-items-center p-3">
                              <div class="icon app-icon-box icon-text bg-body rounded">
                                E
                              </div>
                              <div>
                                <h6>Expense Management</h6>
                                <p class="mb-0 font-size-14">Submit Claims</p>
                              </div>
                            </div>
                          </a>
                          <a href={"/Payslips"} class="app-sub-card">
                            <div class="d-flex align-items-center p-3">
                              <div class="icon app-icon-box icon-text bg-body rounded">
                                S
                              </div>
                              <div>
                                <h6>Self-service</h6>
                                <p class="mb-0 font-size-14">Payslips</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="nav-item nav-icon dropdown">
                    <a
                      href="#"
                      className="circle dropdown-toggle"
                      data-toggle="dropdown"
                      title="Notifications"
                      rel="tooltip"
                      id="notificationDropdownMenuButton"
                    >
                      <i className="ri-notification-3-fill"></i>
                      {/* <span className="dots ></span> */}
                      <span className="notification-count">{notifications?.length}</span>
                    </a>
                    <div className="app-sub-dropdown notification-dropdown dropdown-menu" onClick={(e) => e.stopPropagation()}>
                      <div className="card shadow-none m-2">
                        <div className="card-header cust-title p-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="mb-0">Notifications</h6>
                            <a className="badge badge-info badge-card" href="#">
                              {notifications?.length}
                            </a>
                          </div>
                        </div>
                        <div className="card-body p-0 sub-card">
                          {isLoading ? (
                            <div className="px-3 pt-0 pb-0 text-center">Loading...</div>
                          ) : displayNotifications?.length > 0 ? (
                            displayNotifications?.map(notification => (
                              <a key={notification.id} href="#" className="app-sub-card">
                                <div className="media align-items-center cust-card py-3">
                                  <div className="avatar-notify">
                                    <i className="ri-notification-3-line"></i>
                                  </div>
                                  <div className="media-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                      {/* <h6 className="mb-0">{notification.employeeId}</h6> */}
                                      <small>
                                        <span>{formattedTime(notification.createdDate)}</span>
                                      </small>
                                    </div>
                                    <small className="mb-0">{notification.message}</small>
                                  </div>
                                </div>
                              </a>
                            ))
                          ) : (
                            <div className="px-3 pt-0 pb-0 text-center">No new notifications</div>
                          )}
                        </div>
                        <div className="card-footer text-center">
                          {notifications?.length > 0 && notifications?.length >= displayNotifications?.length && (
                            <a className="btn btn-primary btn-sm" href="#" onClick={handleNextClick} role="button">
                              Next
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </li>

                  <li class="nav-item nav-icon">
                    <a href="#" class="circle" title="Settings" rel="tooltip">
                      <i class="ri-settings-5-fill"></i>
                    </a>
                  </li>

                  <li class="nav-item nav-icon dropdown caption-content pl-4 ml-3 border-left">
                    <a
                      href="#"
                      class=" dropdown-toggle"
                      data-toggle="dropdown"
                      rel="tooltip"
                      id="dropdownMenuButton"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src={user?.Image || image1}
                          class="img-fluid avatar rounded"
                          alt="user"
                        />
                      </div>
                    </a>
                    <div
                      class="app-sub-dropdown dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div class="card shadow-none m-0">
                        <div class="card-body p-0">
                          {/* App Version Display */}
                          <div className="d-flex justify-content-end p-1">
                            <span>App Ver - 2.0</span>
                          </div>
                          <div className="text-center">
                            <div className="user-profile-pic">
                              <img
                                src={user?.Image || image1}
                                alt="profile-img"
                                class="rounded profile-img img-fluid avatar-70"
                              />
                            </div>
                            <div class="p-3">
                              <h6 class="mb-1">{user?.FirstName + " " + user?.LastName}</h6>
                              <p class="mb-1">{user?.OfficialEmail}</p>
                              <p class="mb-1">{user?.Designation}</p>
                              <div class="d-flex align-items-center justify-content-center mt-3">
                                <Link to={'/profile'} class="btn mr-2 btn-primary btn-sm">
                                  Profile
                                </Link>
                                {showSignout && (
                                  <SignoutComponent onClose={handleSignoutClose} />
                                )}
                                <button
                                  className="btn btn-secondary btn-sm"
                                  type="button"
                                  title="Sign Out"
                                  onClick={handleSignoutClick}
                                >
                                  Sign Out
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}
